var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "col col-3 col-lg-2" }, [
        _vm.exhibitor.logo
          ? _c("img", {
              staticClass: "img-thumbnail",
              attrs: {
                src: _vm.exhibitor.logo,
                alt: _vm.exhibitor.company_name,
              },
            })
          : _c("img", {
              staticClass: "img-thumbnail",
              attrs: {
                src: "/media/app/company-symbol.png",
                alt: "company symbol",
              },
            }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col col-9 col-lg-10" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-8 mb-3" }, [
            _c(
              "div",
              [
                _vm.listDisplay
                  ? _c(
                      "router-link",
                      { attrs: { to: _vm.exhibitorUrl(_vm.exhibitor) } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.exhibitor.company_name) +
                            "\n              "
                        ),
                      ]
                    )
                  : _c("span", [_vm._v(_vm._s(_vm.exhibitor.company_name))]),
                _vm._v(" "),
                _c("favorite", {
                  attrs: {
                    attr: _vm.exhibitorType,
                    value: _vm.exhibitor.sfid,
                    obj: _vm.exhibitor,
                  },
                  on: {
                    "favorite-changed": function ($event) {
                      return _vm.$emit("favorite-changed", $event)
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.exhibitor.address))]),
            _vm._v(" "),
            _vm.exhibitor.type != "Exhibitor"
              ? _c("div", { staticClass: "c-title pb-2" }, [
                  _c("i", { staticClass: "fas fa-trophy" }),
                  _vm._v(" " + _vm._s(_vm.exhibitor.type) + "\n            "),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.userIsLoggedIn && _vm.exhibitor.email
              ? _c("span", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-secondary",
                      on: {
                        click: function ($event) {
                          _vm.emailVisible = true
                        },
                      },
                    },
                    [_vm._v("Kontakt")]
                  ),
                  _vm._v(" "),
                  _vm.emailVisible
                    ? _c(
                        "a",
                        {
                          staticClass: "mail-link",
                          attrs: { href: _vm.mailToLink() },
                        },
                        [_vm._v("per Mail.")]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col col-4" }, [
            _c("div", [_vm._v("Halle: " + _vm._s(_vm.exhibitor.hall))]),
            _vm._v(" "),
            _c("div", [_vm._v("Stand: " + _vm._s(_vm.exhibitor.stand))]),
          ]),
          _vm._v(" "),
          _vm.exhibitor.description && _vm.listDisplay
            ? _c("div", { staticClass: "col col-12 mb-3 d-none d-lg-block" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.exhibitor.description) +
                    "\n          "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.exhibitor.description && _vm.listDisplay
        ? _c("div", { staticClass: "col col-12 pt-3 d-lg-none" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-outline float-end",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.descriptionVisible = !_vm.descriptionVisible
                  },
                },
              },
              [
                _vm.descriptionVisible
                  ? _c("i", { staticClass: "fa fa-chevron-down" })
                  : _c("i", { staticClass: "fa fa-chevron-right" }),
              ]
            ),
            _vm._v(" "),
            _vm.descriptionVisible
              ? _c("div", [_vm._v(_vm._s(_vm.exhibitor.description))])
              : _c("div", { staticClass: "c-truncate" }, [
                  _vm._v(_vm._s(_vm.exhibitor.description)),
                ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.exhibitor.description && !_vm.listDisplay
        ? _c("div", { staticClass: "col col-12 pt-3" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.exhibitor.description) + "\n      "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }